import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

interface Iprops{
    open:boolean,
    content: string,
    type: 'success' | 'error',
    handleClose: ()=>void
}

export default function AutohideSnackbar({open, type, content, handleClose}:Iprops) {
  const [vertical, setVertical] = React.useState<'top'>('top')
  const [horizontal, setHorizontal] = React.useState<'center'>('center')
  return (
    <div>
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}  anchorOrigin={{ vertical, horizontal }}>
        <Alert
          onClose={handleClose}
          severity={type}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {content}
        </Alert>
        </Snackbar>
    
    </div>
  );
}
